export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M14 18v-2h-4v2zM3 8h18V6H3zm15 5v-2H6v2z\"/>"
};